// extracted by mini-css-extract-plugin
export var baseButton = "_vy-0";
export var controlsArrowKeys = "_vy-1";
export var controlsResetButton = "_vy-2";
export var lightGameButton = "_vy-4 _vy-0";
export var playAgainButton = "_vy-5 _vy-0";
export var startGameButton = "_vy-3 _vy-0";